export default "__VITE_ASSET__ChbLI$KV__"